module.exports = __webpack_public_path__ + "static/media/icon_chevron_down_curved.fe464f2a.svg";